import {
  serviceMaker,
  methods,
  api
} from "../index.js"

export const viewVendorTemplate = () => serviceMaker(`/vendormanagement`, methods.GET, api.NGB);
export const updateVendorTemplate = (data) => serviceMaker(`/vendormanagement`, methods.POST, api.NGB, data);
export const createVendorTemplate = () => serviceMaker(`/vendormanagement/template`, methods.GET, api.NGB);
export const getByIdVendor = (id) => serviceMaker(`/vendormanagement/${id}?template=true`, methods.GET, api.NGB);
export const updateVendor = (id, data) => serviceMaker(`/vendormanagement/${id}`, methods.PUT, api.NGB, data)